import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

type WrapperProps = {
    $isShowMore: boolean;
};

export const StyledWrapper = styled.div<WrapperProps>`
    background-color: ${getPurpurColor('functionalWhite')};
    position: relative;
    overflow: hidden;
    pointer-events: ${({ $isShowMore }) => ($isShowMore ? 'none' : 'auto')};

    &::before {
        content: '';
        position: absolute;
        z-index: 5;
        bottom: 0;
        left: 0;
        width: 100%;
        height: ${({ $isShowMore }) => ($isShowMore ? '28.5rem' : '0')};
        pointer-events: none;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 50%, ${getPurpurColor('functionalWhite')} 100%);
    }
`;

export const ButtonWrapper = styled.div`
    text-align: center;
    margin: ${getPurpurSpacing('400')} 0 ${getPurpurSpacing('800')} 0;
`;

export const Container = styled.div``;
